import { createBrowserRouter, type RouteObject } from 'react-router';
import { publicRoutes, routes as authRoutes } from '../features/auth/routes';
import { RequireAuth } from '../hooks/useAuth';
import { FEATURES } from './features';
import { Layout } from './Layout';
import { NotFoundPage, RouteError } from './RouteError';

/** Route tree: public routes, then everything else behind RequireAuth inside the app shell. */
export const appRoutes: RouteObject[] = [
  ...publicRoutes.map((route) => ({ ...route, errorElement: <RouteError /> })),
  {
    element: <RequireAuth />,
    errorElement: <RouteError />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            // Pathless boundary so a crashing page keeps the shell (sidebar/top bar) visible.
            errorElement: <RouteError />,
            children: [...Object.values(FEATURES).flatMap((feature) => feature.routes), ...authRoutes, { path: '*', element: <NotFoundPage /> }],
          },
        ],
      },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(appRoutes);
}
